import * as React from "react";
import { StarList } from "./common/StarList";
import { translate } from "@js/common/helpers";
var Global = function (_a) {
    var enabledRatingsCount = _a.enabledRatingsCount, globalRating = _a.globalRating;
    var getRatingsText = function (count) {
        var ratingText = count > 1 ? translate('collection_rating.global.multiple') : translate('collection_rating.global.single');
        return count + " " + ratingText + " " + translate('collection_rating.global.in_total');
    };
    return (React.createElement("div", { id: "ratingGlobal" },
        React.createElement("h5", null, translate('collection_rating.global.title')),
        React.createElement("div", { className: "flex" },
            React.createElement("div", { className: "global-rating" }, globalRating),
            React.createElement("div", null,
                React.createElement(StarList, { note: globalRating }),
                React.createElement("p", null, getRatingsText(enabledRatingsCount))))));
};
export { Global };
